import { useIonModal } from '@ionic/react'

import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { ReceiversFilterModal } from '@apps-common/components/modals/ReceiversFilterModal'
import { DEFAULT_ACTION_BUTTON_COLOR_CLASSES } from '@apps-common/config/colors'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'
import { ICloudReceiverModel } from '@apps-common/types/portal/cloud-receiver'

interface IProps {
  receivers?: ICloudReceiverModel
}

export const ReceiversFilterButton: React.FC<IProps> = ({ receivers }) => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(ReceiversFilterModal, {
    componentProps: {
      receivers
    },
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes={DEFAULT_ACTION_BUTTON_COLOR_CLASSES}
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
    />
  )
}
